// extracted by extract-css-chunks-webpack-plugin
module.exports = {"avatar":"_1AK9ux","xsmall":"_3lqb56","small":"_39xDrD","large":"_1YZarX","responsive":"aBFpYE"};